import { GET_REWARD_HISTORY, SEND_REWARD } from "./types";

const initialState = {
  history: [],
};

const rewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_REWARD_HISTORY:
      return {
        ...state,
        history: action.payload,
      };
    case SEND_REWARD:
      const data = [...state.history];
      data.unshift(action.payload);
      return {
        ...state,
        history: data,
      };

    default:
      return state;
  }
};

export default rewardReducer;
